import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useCreateActivityMutation } from 'features/createActivity/api/createActivityApi';
import { useDispatch } from 'react-redux';
import { useCreatePromoCardDefaultValues } from 'entities/promo/lib/hooks/useCreatePromoCardDefaultValues';
import { ActivityDataСreateUpdateType, PromoStateType } from 'entities/promo/types';
import PromoCard from './PromoCard';

export const CreatePromoCard = () => {
  const dispatch = useDispatch();
  const defaultValues = useCreatePromoCardDefaultValues();
  const [createActivityRequest] = useCreateActivityMutation();

  const [state, setState] = useState<PromoStateType>({
    value: 0,
    formLang: '0',
    isSuccess: false,
    shopDotsOpen: false,
  });

  const { handleSubmit, ...form } = useForm({
    defaultValues,
  });

  const onSubmit = (data: ActivityDataСreateUpdateType) => {
    const transformedData = {
      ...data,
      activity_type_id: data.activity_type_id,
    };

    createActivityRequest({ ...transformedData }).then(() => {
      dispatch(setDrawerOpen(false));
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    });
  };

  return (
    <PromoCard
      state={state}
      setState={setState}
      form={form}
      onSubmit={handleSubmit(onSubmit)}
      textButton="Создать"
    />
  );
};
